import { useQuery } from "@tanstack/react-query";
import { extractQueryState } from "../../helpers/extract-query-state";
import { getPartialCmaPresentationApiClient } from "../../apis/comps/presentation-api-client/api-client-factory";
import { PresentationEditData } from "@cma/presentation-generation-logic";
import { PresentationApiError } from "../../apis/comps/presentation-api-client/http-api-client";

const GET_CMA_PRESENTATION_QUERY_KEY = "get-cma-presentation-edit";
const CACHE_TIME_IN_MS = 1000 * 60 * 5; // 5 minutes

export const buildGetCmaPresentationEditQueryKey = (cmaId: string) => {
  return [GET_CMA_PRESENTATION_QUERY_KEY, cmaId];
};

export function useGetCmaPresentationEdit(props: {
  cmaId: string;
  pooling?: boolean;
  onSuccess?: (data: PresentationEditData) => void;
}) {
  const { cmaId, pooling, onSuccess } = props;
  const api = getPartialCmaPresentationApiClient();

  const query = useQuery<PresentationEditData, PresentationApiError>({
    queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
    queryFn: async () => {
      const response = await api.getPresentationEdit(cmaId);
      if (onSuccess) {
        onSuccess(response);
      }
      return response;
    },
    retry: 1,
    retryDelay: 2000,
    enabled: !!cmaId,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
    refetchInterval: pooling ? 2000 : false,
  });

  return extractQueryState(query);
}
